import moment from "moment-timezone";
import { publicacionVacia } from "./schema";

/* Traducción entre el formulario y el API. Las fechas se leen y se muestran
 * siempre en hora de Argentina, igual que las de los eventos. */

const ZONA = "America/Argentina/Buenos_Aires";
const FORMATO_API = "YYYY-MM-DDTHH:mm:ssZ";
const FORMATO_INPUT = "YYYY-MM-DDTHH:mm";

export const aInstante = (valor) => moment.tz(valor, FORMATO_INPUT, ZONA);

export const toPayload = (form, eventoId) => ({
  ...(form.id ? { id: form.id } : {}),
  idevento: Number(eventoId),
  titulo: form.titulo.trim(),
  descripcion: form.descripcion.trim(),
  desde: aInstante(form.desde).format(FORMATO_API),
  hasta: aInstante(form.hasta).format(FORMATO_API),
  attachs: form.media.map((m) => ({
    url: m.url,
    type: m.type,
    format: m.format,
    public_id: m.public_id,
  })),
});

export const fromPublicacion = (pub) => {
  if (!pub) return publicacionVacia();
  return {
    id: pub.id,
    titulo: pub.titulo ?? "",
    descripcion: pub.descripcion ?? "",
    desde: pub.desde ? moment(pub.desde).tz(ZONA).format(FORMATO_INPUT) : "",
    hasta: pub.hasta ? moment(pub.hasta).tz(ZONA).format(FORMATO_INPUT) : "",
    media: (pub.attachs ?? []).map((a) => ({
      url: a.url,
      type: a.type,
      format: a.format,
      public_id: a.public_id,
    })),
  };
};
